import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import Button from "../../../../componentes/button/button";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import AcaoButtons from "../../Shared/AcaoButtons";
import TipoPagamentoService from "../../../../services/resource/tipoPagamentoService";

const tipoPagamentoService = new TipoPagamentoService();

// Etapa "Pagamento" — registra valor pago/data/forma/comprovante; ao registrar, o processo é finalizado.
export default function EtapaMultaPagamento({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [valorPago, setValorPago] = useState("");
    const [dataPagamento, setDataPagamento] = useState("");
    const [formaPagamento, setFormaPagamento] = useState("");
    const [numeroComprovante, setNumeroComprovante] = useState("");
    const [observacao, setObservacao] = useState("");
    const [tiposPagamento, setTiposPagamento] = useState([]);

    useEffect(() => {
        tipoPagamentoService.listar().then(res => setTiposPagamento(res.data)).catch(() => setTiposPagamento([]));
    }, []);

    const podeRegistrar = acoes.includes("REGISTRAR");

    function registrar() {
        onExecutarAcao("REGISTRAR", {
            comentario: observacao || undefined,
            dados: {
                valorPago: Number(valorPago),
                dataPagamento,
                formaPagamento,
                numeroComprovante: numeroComprovante || undefined,
            },
        });
    }

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Registre os dados do pagamento da multa para finalizar o processo.
            </p>

            {/*
             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input type="number" min="0" step="0.01" label="Valor pago" required value={valorPago} onChange={e => setValorPago(e.target.value)} />
                <Input type="date" label="Data do pagamento" required value={dataPagamento} onChange={e => setDataPagamento(e.target.value)} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                    <label className="text-sm font-medium text-foreground/80">Forma de pagamento <span className="text-destructive">*</span></label>
                    <CustomDropdown value={formaPagamento} onChange={e => setFormaPagamento(e.value)} options={tiposPagamento} optionValue="nome" optionLabel="nome" placeholder="Selecione" filter />
                </div>
                <Input label="Número do comprovante" value={numeroComprovante} onChange={e => setNumeroComprovante(e.target.value)} />
            </div> 
            */}

            <Textarea label="Observações" value={observacao} onChange={e => setObservacao(e.target.value)} rows={3} />

            <p className="text-xs text-muted-foreground">
                <i className="fa fa-info-circle mr-1" />
                Anexe o comprovante de pagamento na seção Anexos.
            </p>

            <div className="flex justify-end">
                {podeRegistrar && (
                    <Button
                        variant="green"
                        label="Registrar pagamento"
                        iconLeft="fa fa-flag-checkered"
                        loading={acaoEmExecucao === "REGISTRAR"}
                        onClick={registrar}
                    />
                )}
            </div>
        </div>
    );
}
